import * as React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";

type Props = {
  label: string;
  value?: string | number;
  setValue: (value: string) => void;
  hasValueError?: boolean;
  setHasValueError?: (state: boolean) => void;
  isRequired?: boolean;
};

export function TextFieldForSearch(props: Props & TextFieldProps) {
  const {
    value,
    setValue,
    hasValueError,
    setHasValueError,
    isRequired,
    label: labelName,
    ...propsOpt
  } = props;

  const inputName = React.useCallback(
    (event: { target: { value: any } }) => {
      const inputValue = event.target.value;
      const isEmpty = inputValue === "";
      setValue(inputValue);
      setHasValueError && setHasValueError(isEmpty);
    },
    [setValue, setHasValueError]
  );

  return (
    <TextField
      {...propsOpt}
      size="small"
      autoComplete="section-blue shipping street-address"
      label={labelName}
      required={isRequired ? true : false}
      value={value || ""}
      error={hasValueError}
      onChange={inputName}
      helperText={hasValueError ? labelName + "を入力してください。" : ""}
    />
  );
}
